window.RXHelpers = {}

import * as trials from "./trials.js";
import * as LocalStorage from "./local_storage.js";

window.RXHelpers.trials = trials;
window.RXHelpers.LocalStorage = LocalStorage;
